import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import "antd/dist/antd.min.css";

import Router from "./router";
import i18n from "./translation";

const App = () => (
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(<App />);
}
